var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F06022",
    d: "M23.006 8.1h-4.511v8.077h4.511z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E91D25",
    d: "M18.782 12.138a5.11 5.11 0 0 1 1.97-4.039 5.166 5.166 0 0 0-7.554 1.314 5.12 5.12 0 0 0 0 5.45 5.15 5.15 0 0 0 2.116 1.894 5.17 5.17 0 0 0 5.439-.581 5.13 5.13 0 0 1-1.97-4.038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59D1E",
    d: "M29.094 12.138c0 .964-.272 1.908-.785 2.725a5.15 5.15 0 0 1-2.117 1.895 5.17 5.17 0 0 1-5.44-.582 5.14 5.14 0 0 0 1.971-4.038 5.12 5.12 0 0 0-1.97-4.039 5.166 5.166 0 0 1 7.557 1.312c.513.817.785 1.762.785 2.726"
  })));
};
export default SvgMastercard;